
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/smart-score-screener",
      function () {
        return require("private-next-pages/tools/smart-score-screener/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/smart-score-screener"])
      });
    }
  